exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leo-field-tip-icon[data-v-1843012a] {\r\n  margin-left: 6px;\r\n  color: #909399;\r\n  cursor: help;\r\n  font-size: 14px;\r\n  vertical-align: middle;\n}\n.leo-field-tip-icon[data-v-1843012a]:hover {\r\n  color: #409eff;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1843012a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LeoKnowledge/LeoFormLabelTip.vue
// module id = SFWw
// module chunks = 546